import React from 'react';
import SkeletonComponent from '../../skeleton_loaders/common/SkeletonComponent.jsx';
import SkeletonGrid from '../../skeleton_loaders/common/SkeletonGrid.jsx';

function OptionGridSkeleton({gridHeight}) {
  return (
    <div style={{marginRight: '1rem'}}>
      <h4><SkeletonComponent /></h4>
      <SkeletonGrid gridHeight={gridHeight} />
    </div>
  )
}

export default OptionGridSkeleton;